export default "__VITE_ASSET__CghrK977__"